/* FIXME: camelcase */
/* eslint-disable camelcase */

export type TargetingRuleMatchOperation =
  | 'simple'
  | 'exact'
  | 'starts_with'
  | 'ends_with'
  | 'contains'
  | 'regex'
  | 'trigger';

export type StateChangeListenMode = 'automatic' | 'automatic_with_fragments' | 'manual';

export type TargetingRuleComponent = 'url' | 'trigger';

export interface SessionTargetingRule {
  component: TargetingRuleComponent;
  match_operation: TargetingRuleMatchOperation;
  pattern: string;
  negate: boolean;
}

export enum CAPTURE_MODE {
  ON = 'on',
  OFF = 'off',
}

export interface SessionsSettings {
  session_capture_mode: CAPTURE_MODE.ON | CAPTURE_MODE.OFF;
  session_exclude_short: boolean;
  session_targeting_rules: SessionTargetingRule[];
  state_change_listen_mode: StateChangeListenMode;
  allowed_iframe_domains: string[];
}
